import type { ConfigTheming } from "@pandas/http-client/configurator";
import * as z from "zod";

export type { ConfigTheming };

export type ThemeType = "light" | "dark";
export type ContrastColor = "white" | "black";

const themeAssetsSchema = z.object({
	navbarBackgroundUrl: z.string().default(""),
	navbarLogo: z.string().default(""),
	navbarPandasLogo: z.string().default(""),
	logo: z.string().default(""),
	locatorLogo: z.string().default(""),
	webappHomePage: z.string().default(""),
	digitizerImage: z.string().default(""),
	splashScreen: z.string().default(""),
});

export type ThemeAssets = z.infer<typeof themeAssetsSchema>;

export const themingOutputSchema = z.object({
	brandColor: z.string().default("#212121"),
	brandColorTransparent: z.string().default("rgba(26, 26, 26, 0.05)"),
	iconColor: z.string().default("#212121"),
	iconLineColor: z.enum(["white", "black"]).default("black"),
	buttonColor: z.string().default("#212121"),
	navbarColor: z.string().default("#212121"),
	navbarButtonColor: z.string().default("#FFFFFF"),
	poweredByPandas: z.boolean().default(false),
	navbarPoweredBy: z.enum(["white", "black"]).default("white"),
	buttonBorderRadius: z.string().default("6.25rem"),
	primaryFonts: z.string().default("Manrope"),
	secondaryFonts: z.string().default("Thicker"),
	assets: themeAssetsSchema.default({
		navbarBackgroundUrl: "",
		navbarLogo: "",
		navbarPandasLogo: "",
		logo: "",
		locatorLogo: "",
		webappHomePage: "",
		digitizerImage: "",
		splashScreen: "",
	}),
});

export type Theming = z.infer<typeof themingOutputSchema>;

export const themingInitialState: Theming = themingOutputSchema.parse({});
